import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ImportFileService {
  fileUploaded = new EventEmitter<void>();
}
